import { HOTEL_SEARCH_ERROR, HOTEL_SEARCH_ID_TYPE } from '@/src/constants/hotels'
import { HotelSearchData, HotelSearchRequestParams, HotelSearchResponse } from '@/src/types/hotels/srp'
import { createApi } from '@reduxjs/toolkit/query/react'
import { createHotelBaseQuery } from './hotelBaseQuery'

// Hotels upstream (Flyin) search: one call returns the full result set; the SRP
// sorts and filters client-side. transformResponse hoists echoToken + currency.
export const hotelSearchApi = createApi({
    reducerPath: 'hotelSearchApi',
    baseQuery: createHotelBaseQuery(),

    tagTypes: ['HotelSearch'],
    keepUnusedDataFor: 600,

    endpoints: builder => ({
        getHotelSearch: builder.query<HotelSearchData, HotelSearchRequestParams>({
            query: params => {
                const search = new URLSearchParams({
                    hotelSearchType: params.hotelSearchType,
                    checkInDate: params.checkInDate,
                    checkOutDate: params.checkOutDate,
                    nights: params.nights,
                    noOfRooms: params.noOfRooms,
                    noOfAdults: params.noOfAdults,
                    noOfChildren: params.noOfChildren,
                    childrenAges: params.childrenAges,
                    language: params.language,
                    cityId: params.cityId,
                    cityName: params.cityName,
                    countryName: params.countryName,
                    arg: 'newSearch',
                    api: 'true',
                    idType: HOTEL_SEARCH_ID_TYPE
                })
                if (params.uniqueId) {
                    search.set('hotelId', params.uniqueId)
                    search.set('uniqueId', params.uniqueId)
                }
                if (params.hotelName) search.set('hotelName', params.hotelName)
                return { url: `/app/hotel/searchHotels?${search.toString()}` }
            },
            transformResponse: (response: HotelSearchResponse): HotelSearchData => ({
                echoToken: response?.data?.uuid || '',
                currency: response?.usc || '',
                rows: response?.data?.searchRS || [],
                showSupplier: response?.data?.searchCriteria?.showCRS === true
            }),
            transformErrorResponse: (response, meta, arg) => ({
                status: response.status,
                error: HOTEL_SEARCH_ERROR,
                message: `Hotel search request failed with status ${response.status}`,
                cityId: arg.cityId,
                data: response.data || {}
            }),
            providesTags: (result, error, params) => [
                { type: 'HotelSearch', id: params.uniqueId || params.cityId || 'search' }
            ]
        })
    })
})

export const { useGetHotelSearchQuery, useLazyGetHotelSearchQuery } = hotelSearchApi

export default hotelSearchApi
